import {store} from '../store/store';


export default function auth({ next }) {
    if (store.getters['user/auth/logged']) {
        return next();
    }
    store.dispatch('user/auth/requireLogin', true);
}



// WEBPACK FOOTER //
// ./src/middleware/auth.js